import React from "react";
import { RouteObject } from "react-router-dom";
import { Stockanywhere } from "../layouts/Stockanywhere";
import { Products } from "../pages/stockanywhere/products/Products";
import { ProductsVarieties } from "../pages/stockanywhere/products/ProductsVarieties";
import { Assets } from "../pages/stockanywhere/products/Assets";
import { Channels } from "../pages/stockanywhere/products/Channels";
import { Locations } from "../pages/stockanywhere/products/Locations";
import { Customers } from "../pages/stockanywhere/products/Customers";
import { Orders } from "../pages/stockanywhere/products/Orders";


export const StockanywhereRoutes: RouteObject[] = [
    {
        path: "/",
        element: <Stockanywhere/>,
        children: [
            {
                path: "",
                element: <div>...</div>,
            },
        ],
    },
    {
        path: "assets",
        element: <Stockanywhere/>,
        children: [
            {
                path: "",
                element: <Assets />,
            },
        ]
    },
    {
        path: "channels",
        element: <Stockanywhere/>,
        children: [
            {
                path: "",
                element: <Channels />,
            },
        ]
    },
    {
        path: "customers",
        element: <Stockanywhere/>,
        children: [
            {
                path: "",
                element: <Customers />,
            },
        ]
    },
    {
        path: "locations",
        element: <Stockanywhere/>,
        children: [
            {
                path: "",
                element: <Locations />,
            },
        ]
    },
    {
        path: "orders",
        element: <Stockanywhere/>,
        children: [
            {
                path: "",
                element: <Orders />,
            },
        ]
    },
    {
        path: "products",
        element: <Stockanywhere/>,
        children: [
            {
                path: "",
                element: <Products />,
            },
        ]
    },
    {
        path: "product_varieties",
        element: <Stockanywhere/>,
        children: [
            {
                path: "",
                element: <ProductsVarieties/>,
            },
        ]
    },
    {
        path: "amazon",
        element: <Stockanywhere/>,
        children: [
        ]
    },	
    {
        path: "google_merchant_centre",
        element: <Stockanywhere/>,
        children: [
        ]
    },
    {
        path: "shopify",
        element: <Stockanywhere/>,
        children: [	

        ],
    },	
    {
        path: "takealot",
        element: <Stockanywhere/>,
        children: [
        ]
    },	
    {
        path: "woocommerce",
        element: <Stockanywhere/>,
        children: [
        ]
    },
 
];

